import { useMemo } from "react";
import { ConstraintConfigType } from "types/ConstraintsTypes";
import { ConstraintContent } from "../ConstraintContent";
import { useFeeType } from "pages/assistant/hooks/useFeeType";
import activityPanelStore from "shared/store/activityPanelStore";

type IndicatorContentProps = {
  configData: ConstraintConfigType;
};

export function IndicatorContent({ configData }: IndicatorContentProps) {
  const feeType = useFeeType();
  const constraintsPanelMode = activityPanelStore((state) => state.constraintsPanelMode);
  const isRebalancing = constraintsPanelMode !== 'builder';

  const disabledKeys = useMemo(() => {
    if (!isRebalancing || !feeType) return undefined;
    if (feeType === 'feeOnTop') return ['final_score_advice_min', 'final_score_advice_max'];
    if (feeType === 'feeOnly') return ['final_score_min', 'final_score_max'];
    return undefined;
  }, [isRebalancing, feeType]);

  return (
    <ConstraintContent
      configData={configData}
      dataKey="indicator"
      notEditableValue={{
        value: "10.00",
        label: "Max:",
      }}
      disabledKeys={disabledKeys}
    />
  );
}
